import { debounce } from "HelperFunctions";

export const ListWidgetNav = (): void => {
    const moveElements = (): void => {
        if (window.innerWidth < 768) return;

        const carouselWidgets: NodeListOf<HTMLElement> = document.querySelectorAll(".jobs-block");
        if (!carouselWidgets.length) return;

        carouselWidgets.forEach((carousel: HTMLElement) => {
            const tabsContainer: HTMLElement | null = carousel.querySelector(".attrax-list-widget__tabs");
            if (!tabsContainer || tabsContainer.querySelector(".attrax-list-widget__nav")) return;

            const findOpenPositionsButton: HTMLElement | null = carousel.querySelector("a.attrax-button[href='/Jobs']");
            const tabHeading: HTMLElement | null = tabsContainer.querySelector(".attrax-list-widget__tab-heading");

            if (!findOpenPositionsButton && !tabHeading) return;

            const navContainer: HTMLDivElement = document.createElement("div");
            navContainer.classList.add("attrax-list-widget__nav");

            if (tabHeading) navContainer.appendChild(tabHeading);
            if (findOpenPositionsButton) navContainer.appendChild(findOpenPositionsButton);

            tabsContainer.appendChild(navContainer);
        });
    };

    moveElements();
    window.addEventListener("resize", debounce(moveElements, 250));
};
